import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetPayoutStatusRequestDto } from "../../dtos/get-payout-status-request-dto";
import type { GetPayoutStatusResponseDto } from "../../dtos/get-payout-status-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetPayoutStatusQueryParams = {
  queryParams: GetPayoutStatusRequestDto;
  options?: Omit<UseQueryOptions<GetPayoutStatusResponseDto>, "queryKey">;
};

export const useGetPayoutStatusQuery = ({
  queryParams,
  options
}: UseGetPayoutStatusQueryParams) => {
  return useQuery({
    queryKey: OrderQueryKeys.getPayoutStatus(queryParams.orderId).queryKey,
    queryFn: async () =>
      await OrderService.getPayoutStatus({ payload: queryParams }),
    ...options
  });
};
